import { render, staticRenderFns } from "./Masalar.vue?vue&type=template&id=8766928c&scoped=true&"
import script from "./Masalar.vue?vue&type=script&lang=js&"
export * from "./Masalar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8766928c",
  null
  
)

export default component.exports